import { render, staticRenderFns } from "./lawMakingReviewDetail.vue?vue&type=template&id=67193de4"
import script from "./lawMakingReviewDetail.vue?vue&type=script&lang=js"
export * from "./lawMakingReviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67193de4')) {
      api.createRecord('67193de4', component.options)
    } else {
      api.reload('67193de4', component.options)
    }
    module.hot.accept("./lawMakingReviewDetail.vue?vue&type=template&id=67193de4", function () {
      api.rerender('67193de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/review/lawMakingReviewDetail.vue"
export default component.exports